import { gridGutterHalf, fontSizeBase, fontSize24, fontSize12, fontSize20 } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout'
import { white, grayBorder, green, grayShadow, blue, grayFont } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors'
import { flexWrapper } from '../style'

export const flex = `
  ${flexWrapper};

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }

  .flex-item {
    flex: 1;

    i {
      font-weight: 700;
      font-size: ${fontSize20};
    }

    @media screen and (max-width: 991px) {    
      margin-bottom: ${gridGutterHalf}px;
    }
  }
`

export const switchWrapper = `
  margin: 0 ${gridGutterHalf}px;
  position: relative;

  @media screen and ( max-width: 767px ) {
    margin: 0
  }
`

export const switchButton = isVisible => ` 
  font-size: ${fontSize12} ;
  position: absolute;
  bottom: 5px;
  left: calc(50% - 20px);
  z-index: 1;
  color: ${green};
  border-radius: 50%;
  border: 1px solid ${grayBorder};
  outline: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
  box-shadow: 0 2px 1px ${grayShadow};
  background: ${white};  

  i {
    font-weight: 700;
    display: inline-block;
    pointer-events: none;
    transition: all 300ms ease;
    
  }
  
  &.switchMotion {
    i {
      transform: rotate(180deg);
    }
  }

  &[disabled] {
    color: ${grayFont};
    pointer-events: none;
    
    i {
      opacity: 0.5;
    }
  }
  
  @media screen and ( max-width: 991px ) {
    bottom: 17px;
  }
  
  @media screen and ( max-width: 767px ) {
    right: 0;
    left: auto;
    top: -15px;
    bottom: initial;
    display: ${isVisible ? "block" : "none"};

    i {
      transform: rotate(90deg);
    }

    &.switchMotion {
      i {
        transform: rotate(270deg);
      }
  }
`

export const airportList = `
  min-height: 50px;
  cursor: pointer;
  font-size: ${fontSize12};
  padding: ${gridGutterHalf}px;
  border-bottom: 1px solid ${grayBorder};

  .airport-list-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .airport-content {
    flex: 1;
    justify-self: start;
    margin-right: ${gridGutterHalf}px;
  }
  
  .airport-name {
    color: ${blue};
    display: block;
  }
  
  .iata {
    color: #6f869b;
    font-weight: 400;
    font-size: ${fontSizeBase};
  }

  i {
    display: inline-block;
    color: ${grayFont};
    font-size: ${fontSize24};
    margin-right: ${gridGutterHalf}px;
  }
`